<ngx-spinner
  bdColor="rgba(51,51,51,0.5)"
  size="medium"
  color="#ccc"
  type="ball-scale-multiple">
  <p class="loading-msg">{{ spinnerMessage$ | async }}</p>
</ngx-spinner>
<app-inactivity-progress-bar *ngIf="!isTvScreen"></app-inactivity-progress-bar>
<router-outlet></router-outlet>
<router-outlet name="popup"></router-outlet>
